import { render } from "./ArticleSummary.vue?vue&type=template&id=36a5b5d2&scoped=true&ts=true"
import script from "./ArticleSummary.vue?vue&type=script&lang=ts"
export * from "./ArticleSummary.vue?vue&type=script&lang=ts"

import "./ArticleSummary.vue?vue&type=style&index=0&id=36a5b5d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a5b5d2"]])

export default __exports__